import React, { useState } from 'react'

import ImgUtil from '../../../../utils/img.utils'
import { internalLinkHandler } from '../../../../utils/link.utils'
import { renderRichText } from '../../../../utils/richTextHandler.utils'
import formatInlineCode from '../../../../utils/shortTextFormatting'
import Button from '../../../global/button'
import Typography from '../../typography'
import WrapperImage from '../../wrapperImage'

import { MtvDataType } from '../../../../models/components/mediaTextVariants'

type Props = {
  mtvData: MtvDataType
  mainImgPath: string
  mainImgAlt: string
}
export const TabsLayout = ({ mtvData, mainImgPath, mainImgAlt }: Props) => {
  const [ActiveState, setActiveState] = useState(0)

  const toggleTab = (index: number) => {
    setActiveState(index)
  }

  const getActiveClass = (index: number, className: string) =>
    ActiveState === index ? className : ''

  return (
    <>
      <div className="Tab__List">
        <ul>
          {mtvData.map((tabs, index: number) => {
            return (
              <li
                onClick={() => toggleTab(index)}
                className={`tab-item ${getActiveClass(index, 'active')}`}
                key={index}>
                {tabs?.title}
              </li>
            )
          })}
        </ul>
      </div>
      <div className="Tabs__Container">
        {mtvData.map((tabs, index: number) => {
          const tabImgPath = tabs?.media?.image?.file?.url || ''
          const tabImgAlt = tabs?.media?.altText || ''

          return (
            <div className={`Tab__Content ${getActiveClass(index, 'active')}`} key={index}>
              <div className="Tab__Content-Left">
                <Typography type="header3" className="Tab__Content-title">
                  {formatInlineCode(tabs?.headline)}
                </Typography>
                {tabs?.body && (
                  <Typography type="bodyXL" className="Tab__Content-desc">
                    {renderRichText(tabs?.body)}
                  </Typography>
                )}
                {tabs?.cta && (
                  <Button
                    icon={true}
                    href={
                      tabs?.cta?.internalLink
                        ? internalLinkHandler(tabs?.cta?.internalLink)
                        : tabs?.cta?.externalUrl
                    }
                    text={tabs?.cta?.text}
                    type="text-link"
                    size="small"
                    theme={'light'}
                  />
                )}
              </div>
              <div className="Tab__Content-Right">
                <WrapperImage
                  src={ImgUtil.getResizedImageUrl(
                    tabImgPath ? tabImgPath : mainImgPath,
                    `height=600`
                  )}
                  alt={tabImgAlt ? tabImgAlt : mainImgAlt}
                  threshold={650}
                  className="Tab-image"
                />
              </div>
            </div>
          )
        })}
      </div>
    </>
  )
}
